/**
 * The donation form's title strip names the intent, not the pick (Paper 2JU-0, 00 Decisions
 * 4NE-0 item 13 "Title strip = stable intent; CTA = dynamic amount"). The amount and the
 * frequency live in the button ("Give $25 monthly"). Event forms say "Get tickets".
 */
export const FORM_TITLE_STRIP = 'Make a gift';

/** The monthly upsell step's title strip (owner call 2026-10-21). */
export const MONTHLY_BUMP_TITLE_STRIP = 'Make your gift monthly';
